import { RelationSublistConfigKey } from '@/utils/CRUD/read/relational/const'

export const RELATION_CONFIGS: Record<string, RelationSublistConfigKey[]> = {
  Activity: [
    RelationSublistConfigKey.ACTIVITY_PERSON,
    RelationSublistConfigKey.ACTIVITY_COMPANY,
  ],
  Company: [RelationSublistConfigKey.COMPANY_PERSON],
  Person: [RelationSublistConfigKey.PERSON_COMPANY],
}
